'use client'

import React, { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUpload } from '@fortawesome/free-solid-svg-icons'
import ReactQuill from 'react-quill'
import "react-quill/dist/quill.snow.css"
import axios from 'axios'
import { Form, Button, Container, Image, InputGroup } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { Recipe } from './tipos/Recipe'
import { Ingredient } from './tipos/Ingredient'
import { useParams, useNavigate } from 'react-router-dom'

export default function RecipeForm() {
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')
  const [description2, setDescription2] = useState('')
  const [description3, setDescription3] = useState('')
  const [description4, setDescription4] = useState('')
  const [description5, setDescription5] = useState('')
  const [bdes2, setBdes2] = useState(false)
  const [bdes3, setBdes3] = useState(false)
  const [bdes4, setBdes4] = useState(false)
  const [bdes5, setBdes5] = useState(false)
  const [portada, setPortada] = useState('')
  const [preptime, setPreptime] = useState('')
  const [dificultad, setDificultad] = useState('')
  const [raciones, setRaciones] = useState(1)
  const [cooktime, setCooktime] = useState('')
  const { t } = useTranslation()
  const [ingredientes, setIngredientes] = useState<Ingredient[]>([])
  const [file, setFile] = useState<File | null>(null)
  const [previewUrl, setPreviewUrl] = useState<string | null>(null)
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()
  const [urlVideo, setUrlVideo] = useState('')
  const [video, setVideo] = useState('')

  useEffect(() => {
    const fetchRecipe = async () => {
      if (id && id !== 'new') {
        try {
          const response = await axios.get<Recipe>(`https://rednext31.ddns.net:3005/api/recipes/${id}`)
          const { title, description, description2, description3, description4, description5, bdes2, bdes3, bdes4, bdes5, portada, preptime, dificultad, raciones, cooktime, ingredientes, urlVideo, video } = response.data
          setTitle(title)
          setDescription(description)
          setDescription2(description2 || '')
          setDescription3(description3 || '')
          setDescription4(description4 || '')
          setDescription5(description5 || '')
          setBdes2(bdes2 || false)
          setBdes3(bdes3 || false)
          setBdes4(bdes4 || false)
          setBdes5(bdes5 || false)
          setPortada(portada)
          setPreptime(preptime)
          setDificultad(dificultad)
          setRaciones(raciones)
          setCooktime(cooktime)
          setIngredientes(ingredientes)
          setPreviewUrl(portada)
          setUrlVideo(urlVideo)
          setVideo(video)
        } catch (error) {
          console.error('Error fetching recipe:', error)
        }
      } else {
        resetForm()
      }
    }

    fetchRecipe()
  }, [id])

  const resetForm = () => {
    setTitle('')
    setDescription('')
    setDescription2('')
    setDescription3('')
    setDescription4('')
    setDescription5('')
    setBdes2(false)
    setBdes3(false)
    setBdes4(false)
    setBdes5(false)
    setPortada('')
    setPreptime('30')
    setDificultad('')
    setRaciones(1)
    setCooktime('30')
    setIngredientes([])
    setFile(null)
    setPreviewUrl(null)
    setUrlVideo('')
    setVideo('')
  }

  const handleRecipeSubmit = async (recipe: Partial<Recipe>) => {
    try {
      if (recipe.id) {
        await axios.put(`https://rednext31.ddns.net:3005/api/recipes/${recipe.id}`, recipe)
      } else {
        await axios.post('https://rednext31.ddns.net:3005/api/recipes', recipe)
      }
      navigate('/apartadoD')
    } catch (error) {
      console.error('Error submitting recipe:', error)
    }
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    const recipeData: Partial<Recipe> = {
      id: id && id !== 'new' ? parseInt(id) : undefined, 
      title, 
      description,
      description2,
      description3,
      description4,
      description5,
      bdes2,
      bdes3,
      bdes4,
      bdes5,
      portada, 
      preptime, 
      dificultad, 
      raciones, 
      cooktime, 
      ingredientes,
      urlVideo,
      video
    }
    await handleRecipeSubmit(recipeData)
  }

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const selectedFile = e.target.files[0]
      setFile(selectedFile)
      setPortada(URL.createObjectURL(selectedFile))
      setPreviewUrl(URL.createObjectURL(selectedFile))
    }
  }

  const handleUpload = async () => {
    if (!file) {
      alert(t('apartadoB.selectFileFirst'))
      return
    }

    const formData = new FormData()
    formData.append('file', file)

    try {
      const response = await axios.post('https://rednext31.ddns.net:3005/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      alert(t('apartadoB.uploadSuccess'))
      setPortada(response.data.filePath)
      alert(response.data.filePath)
    } catch (error) {
      console.error('Error uploading file:', error)
      alert(t('apartadoB.uploadError'))
    }
  }

  const handleAddIngredient = () => {
    setIngredientes([...ingredientes, { id_ingr: 0, name: '', unit: '', quantity: 0 }])
  }

  const handleDeleteIngredient = (index: number) => {
    setIngredientes(ingredientes.filter((_, i) => i !== index))
  }
  
  const modules = {
    toolbar: [
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'align': [] }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }, { indent: "-1" }, { indent: "+1" }],
      ['link', 'image'],
      ['clean']
    ]
  }

  const isYouTubeUrl = (url: string | string[]) => url.includes('youtube.com') || url.includes('youtu.be')

  const handleIntegrarVideo = async () => {
    try {
      const encodedURL = encodeURIComponent(urlVideo)
      const response = await axios.post(
        'https://rednext31.ddns.net:3005/videos',
        JSON.stringify({ encodedURL }),
        { 
          headers: {
             'Content-Type': 'application/json' 
          }
        }
      )
      setUrlVideo(response.data.filePath)
      setVideo(response.data.filePath)
    } catch (error) {
      console.error('Error uploading file:', error)
    }
  }

  return (
    <Container className="my-5">
      <h2>{id && id !== 'new' ? t('recipe.editRecipe') : t('recipe.addRecipe')}</h2>
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label><b>{t('recipe.title')}</b></Form.Label>
          <Form.Control 
            type="text" 
            value={title} 
            onChange={(e) => setTitle(e.target.value)} 
            required 
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label><b>{t('recipe.description')} 1</b></Form.Label>
          <ReactQuill 
            value={description} 
            onChange={setDescription} 
            modules={modules} 
          />
        </Form.Group>

        {[2, 3, 4, 5].map((num) => (
          <React.Fragment key={num}>
            <Form.Check 
              type="checkbox"
              label={`Habilitar descripción ${num}`}
              checked={eval(`bdes${num}`)}
              onChange={() => eval(`setBdes${num}(!bdes${num})`)}
              className="mb-3"
            />
            {eval(`bdes${num}`) && (
              <Form.Group className="mb-3">
                <Form.Label><b>{t('recipe.description')} {num}</b></Form.Label>
                <ReactQuill 
                  value={eval(`description${num}`)} 
                  onChange={(content) => eval(`setDescription${num}(content)`)} 
                  modules={modules} 
                />
              </Form.Group>
            )}
          </React.Fragment>
        ))}

        <Form.Group className="mb-3">
          <Form.Label><b>{t('recipe.labelImagenDePortada')}</b></Form.Label>
          <Form.Control 
            type="text" 
            value={portada} 
            onChange={(e) => setPortada(e.target.value)} 
          />
        </Form.Group>

        <Form.Group className="mb-3">
          {previewUrl && (
            <Image src={previewUrl} alt="Preview" thumbnail className="mt-2 mb-3" style={{maxWidth: '200px'}} />
          )}
        </Form.Group>    
        <Form.Group className="mb-3">
          <InputGroup>
            <InputGroup.Text>
              <FontAwesomeIcon icon={faUpload} />
            </InputGroup.Text>
            <Form.Control type="file" onChange={handleFileChange} accept="image/*"/>
          </InputGroup>  
          <Button variant="outline-primary" onClick={handleUpload} disabled={!file}>{t('apartadoB.uploadFile')}</Button>
        </Form.Group>

        <Form.Group className="mb-3">
          {urlVideo && isYouTubeUrl(urlVideo) ? (
            <div>
              <iframe
                width="600"
                height="400"
                src={`https://www.youtube.com/embed/${urlVideo.split('v=')[1]}`}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            ) : (
              urlVideo && (
              <div>
              <video controls width="600">
                <source src={urlVideo} type="video/mp4" />
                {'video no soportado'}
              </video>
            </div>
          )
        )}
        </Form.Group>
        <Form.Group controlId="formBasicUrl">
            <Form.Label><b>URL VIDEO:</b></Form.Label>
            <Form.Control 
                type="url" 
                value={urlVideo} 
                onChange={(e) => setUrlVideo(e.target.value)} 
                placeholder="https://ejemplo.com"
                />
        </Form.Group>
        {
          !video && (
                      <Button variant="primary" onClick={handleIntegrarVideo}>Integrar</Button>
                    )
        }
        <Form.Group className="mb-3">
          <Form.Label><b>{t('recipe.preptime')}</b></Form.Label>
          <Form.Control 
            type="text" 
            value={preptime} 
            onChange={(e) => setPreptime(e.target.value)} 
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label><b>{t('recipe.difficulty')}</b></Form.Label>
          <Form.Select 
            value={dificultad} 
            onChange={(e) => setDificultad(e.target.value)}
          >
            <option value="">{t('recipe.selectDifficulty')}</option>
            <option value="Fácil">{t('recipe.easy')}</option>
            <option value="Media">{t('recipe.medium')}</option>
            <option value="Difícil">{t('recipe.hard')}</option>
          </Form.Select>
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label><b>{t('recipe.servings')}</b></Form.Label>
          <Form.Control 
            type="number" 
            value={raciones} 
            onChange={(e) => setRaciones(parseInt(e.target.value))} 
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label><b>{t('recipe.cooktime')}</b></Form.Label>
          <Form.Control 
            type="text" 
            value={cooktime} 
            onChange={(e) => setCooktime(e.target.value)} 
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label><b>{t('recipe.ingredients')}</b></Form.Label>
          {ingredientes.map((ingrediente, index) => (
            <div key={index} className="d-flex align-items-center mb-2">
              <Form.Control
                type="text"
                value={ingrediente.name}
                onChange={(e) => {
                  const updatedIngredientes = [...ingredientes]
                  updatedIngredientes[index].name = e.target.value
                  setIngredientes(updatedIngredientes)
                }}
                placeholder={t('recipe.ingredientName')}
                className="me-2"
              />
              <Form.Control
                type="number"
                value={ingrediente.quantity}
                onChange={(e) => {
                  const updatedIngredientes = [...ingredientes]
                  updatedIngredientes[index].quantity = parseFloat(e.target.value)
                  setIngredientes(updatedIngredientes)
                }}
                placeholder={t('recipe.quantity')}
                className="me-2"
              />
              <Form.Control
                type="text"
                value={ingrediente.unit}
                onChange={(e) => {
                  const updatedIngredientes = [...ingredientes]
                  updatedIngredientes[index].unit = e.target.value
                  setIngredientes(updatedIngredientes)
                }}
                placeholder={t('recipe.unit')}
                className="me-2"
              />
              <Button variant="outline-danger" onClick={() => handleDeleteIngredient(index)}>{t('recipe.deleteIngredient')}</Button>
            </div>
          ))}
          <Button variant="outline-secondary" onClick={handleAddIngredient}>{t('recipe.addIngredient')}</Button>
        </Form.Group>
        <Button variant="outline-primary" type="submit">{id && id !== 'new' ? t('recipe.update') : t('recipe.create')}</Button>
      </Form>
    </Container>
  )
}